import styled from 'styled-components'

import AcornsWhiteIcon from 'assets/icons/acorn-white.svg'
import Button from 'components/Button'
import Layout from 'components/Layout'
import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const ActionWrapper = styled.div`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background-color: white;
    bottom: 0;
    left: 0;
    padding: 10px 0 0 0;
    position: fixed;
    width: 100%;
  }
`

export const Container = styled.div`
  text-align: center;
  display: block;
  margin: 0 auto;
  width: 100%;
  justify-content: center;
`

export const Grid = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  flex: 50% 50%;
  margin: 40px 0 40px 0;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    flex: 100%;
    justify-content: center;
    margin: 0 0 100px 0;
  }
`

export const FormRow = styled.div`
  box-shadow: ${style(theme => theme.shadows.smMedium)};
  border-radius: 10px;
  display: block;
  font-size: 14px;
  height: 80px;
  line-height: 22px;
  margin-bottom: 20px;
  margin-left: 20px;
  padding: 20px;
  text-align: left;
  width: 310px;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    width: 304px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-left: 0;
    margin-bottom: 10px;

    width: 315px;
  }
`

export const Label = styled.div`
  display: block;
  position: relative;
  margin-left: 55px;
  text-align: left;
  bottom: 40px;
  width: 225px;
`

export const Padding = styled.div`
  display: block;
  width: 100%;
  height: 30px;
`

export const StyledTitle = styled(Heading2)`
  font-size: 22px;
  line-height: 30px;
  margin: 35px auto 6px;
`

export const StyledBody = styled(Body)`
  font-size: 14px;
  line-height: 22px;
  margin: 0 auto 20px;
  max-width: 340px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 30px;
  }
`

export const StyledBodyLeftAlign = styled(StyledBody)`
  margin-left: 0;
  text-align: left;
`

export const StyledButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px 10px;
  width: 262px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    bottom: 15px;
    height: 44px;
    margin: 0 20px 20px 20px;
    position: sticky;
    width: calc(100vw - 40px);
  }
`

export const StyledCurrencyInput = styled.div`
  color: ${style(theme => theme.colors.green)};
  font-size: 30px;
  line-height: 35.16px
  margin: -15px 0 15px;
`

export const StyledIcon = styled.div`
  background-color: #74c947;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  height: 36px;
  left: 0;
  position: relative;
  width: 36px;

  &:before {
    content: url(${AcornsWhiteIcon});
    position: relative;
    top: 3px;
  }
`

export const StyledTextButton = styled(Button)`
  background-color: white;
  height: 22px;
  line-height: 22px;
  margin-top: 20px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-top: 7px;
  }
`

export const StyledLayout = styled(Layout)`
  padding: 10px 0px 14px 0px;
`

export const TotalCost = styled.div`
  color: ${style(theme => theme.colors.stone)};
  display: block;
  font-size: 12px;
`

export const TransactionTitle = styled.div`
  margin-bottom: -3px;
`

export const RoundupCost = styled.div`
  font-weight: 600;
  position: relative;
  bottom: 45%;
  transform: translateY(-45%);
  float: right;
`
